
  import PageHeader from '@/components/core/PageHeader';
  import tableLoading from '@/components/tableLoading';
  import NoContent from '@/components/customer-content/NoContent'
  import Orderdetailsbox from '@/components/customer-content/orderdetailsbox.vue';

  export default {
    components: {
      PageHeader,
      tableLoading,
      Orderdetailsbox,
      NoContent,
    },
    head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'robots',
            name: 'robots',
            content: 'noindex'
          },
        ],
      }
    },
    data() {
      return {
        title: 'My Tickets',
        orderId: null,
        skip: 0,
        page: 0,
        totalNumberOfpages: 0,
        tickets: {},
        loading: true,
        ticketLoading: true,
      }
    },
    // Check login token
    mounted() {
      if (localStorage.getItem("authToken") != (null || undefined)) {
        this.token = localStorage.getItem("authToken");
        let pagination = (this.page - 1) * 12;
        if (pagination < 0) {
          pagination = 0;
        }
        this.getTickets(pagination);
      } else {
        this.$router.push({
          path: '/accounts/login/'
        })
      }
    },
    methods: {
      // callback for the pagination plugin
      callback: function (page) {
        this.page = page;
        let pagination = (page - 1) * 12;
        if (pagination < 0) {
          pagination = 0;
        }
        this.getTickets(pagination);
      },
      // TO get tickets using pagination
      getTickets(skip) {
        this.ticketLoading = true;
        var formData = new URLSearchParams();
        formData.append("skip", skip);
        // Add header for the API
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          'Authorization': this.token,
        };
        // AXIOS api call to add review api
        this.$axios.post("/api/orders/app/myTickets", formData, {
            headers: headers
          })
          .then(response => {
            let value = this.getCryptKey(response.data);
            this.tickets = value;
            if (skip == 0) {
              this.page = 0;
            }
            this.totalNumberOfpages = Math.ceil(this.tickets.totalCount / 12);
            this.$nextTick(() => {
              this.ticketLoading = false;
            })
          })
          .catch(error => {
            this.$nextTick(() => {
              this.ticketLoading = false;
            })
          })
          .finally(() => {
            this.$nextTick(() => {
              this.ticketLoading = false;
            })
          })
      },
      activitiesImage(post) {
        if (post.thumbnail) {
          return post.thumbnail;
        } else {
          if (post.gallery && post.gallery.length > 0)
            return post.gallery[0]
          return '';
        }
      },
    },
  }

